module.exports = __webpack_public_path__ + "media/images/medal-cff0e389ad3120d3579deaebcfb66860.svg";